export const environment = {
    production: true,
    environmentName: 'production',

    backend:{
        url: 'https://contabilidad-digital.transtecnia.cl',
        port: '',
        api_version: 'api-confinanzas'
    },


    useBackend: true,
    isApiReady: false,

    getURL: function(url): string{     
        return this.getBackendUrl(url)    
    },
    
    getBackendUrl: function(url): string{
        return this.backend.url 
        + (this.backend.port !== '' ? (':' + this.backend.port) : '') 
        + '/' + this.backend.api_version + '/' + url;
    }
};




